export var InternalAuthenticationResultType;
(function (InternalAuthenticationResultType) {
    InternalAuthenticationResultType[InternalAuthenticationResultType["Failure"] = 0] = "Failure";
    InternalAuthenticationResultType[InternalAuthenticationResultType["Success"] = 1] = "Success";
    InternalAuthenticationResultType[InternalAuthenticationResultType["FailureWithValidationErrorsToDisplay"] = 2] = "FailureWithValidationErrorsToDisplay";
    InternalAuthenticationResultType[InternalAuthenticationResultType["FailureWithRedirectionInstructions"] = 3] = "FailureWithRedirectionInstructions";
})(InternalAuthenticationResultType || (InternalAuthenticationResultType = {}));
export var FailedAuthenticationRedirectionType;
(function (FailedAuthenticationRedirectionType) {
    FailedAuthenticationRedirectionType[FailedAuthenticationRedirectionType["None"] = 0] = "None";
    FailedAuthenticationRedirectionType[FailedAuthenticationRedirectionType["MalteseTCNRestrictedSelfRegLogin"] = 1] = "MalteseTCNRestrictedSelfRegLogin";
    FailedAuthenticationRedirectionType[FailedAuthenticationRedirectionType["FailureWithValidationErrorsToDisplay"] = 2] = "FailureWithValidationErrorsToDisplay";
    FailedAuthenticationRedirectionType[FailedAuthenticationRedirectionType["FailureWithRedirectionInstructions"] = 3] = "FailureWithRedirectionInstructions";
    FailedAuthenticationRedirectionType[FailedAuthenticationRedirectionType["EmailAlreadyExists"] = 4] = "EmailAlreadyExists";
    FailedAuthenticationRedirectionType[FailedAuthenticationRedirectionType["LockedAccount"] = 5] = "LockedAccount";
    FailedAuthenticationRedirectionType[FailedAuthenticationRedirectionType["DataMismatch"] = 6] = "DataMismatch";
    FailedAuthenticationRedirectionType[FailedAuthenticationRedirectionType["UnderMinimumAge"] = 7] = "UnderMinimumAge";
    FailedAuthenticationRedirectionType[FailedAuthenticationRedirectionType["UnsupportedDocumentType"] = 8] = "UnsupportedDocumentType";
})(FailedAuthenticationRedirectionType || (FailedAuthenticationRedirectionType = {}));
export var B2Cproviders;
(function (B2Cproviders) {
    B2Cproviders[B2Cproviders["Legacy"] = -1] = "Legacy";
    B2Cproviders[B2Cproviders["NONE"] = 0] = "NONE";
    B2Cproviders[B2Cproviders["CORP"] = 1] = "CORP";
    B2Cproviders[B2Cproviders["EID"] = 2] = "EID";
    B2Cproviders[B2Cproviders["SELF"] = 3] = "SELF";
    B2Cproviders[B2Cproviders["EIDAS"] = 4] = "EIDAS";
})(B2Cproviders || (B2Cproviders = {}));
export var RolesUserTypes;
(function (RolesUserTypes) {
    RolesUserTypes["BasicCorpUser"] = "BasicCorpUser";
    RolesUserTypes["SuperAdmin"] = "SuperAdmin";
    RolesUserTypes["NoRole"] = "No role";
})(RolesUserTypes || (RolesUserTypes = {}));
export var RoleAttributes;
(function (RoleAttributes) {
    RoleAttributes[RoleAttributes["IsSystemRole"] = 1] = "IsSystemRole";
    RoleAttributes[RoleAttributes["IsCorpUsersRole"] = 2] = "IsCorpUsersRole";
    RoleAttributes[RoleAttributes["IsAssignable"] = 3] = "IsAssignable";
    RoleAttributes[RoleAttributes["IsMutuallyExclusive"] = 4] = "IsMutuallyExclusive";
})(RoleAttributes || (RoleAttributes = {}));
